<script>
function getStyle(slot, context) {
  if (
    slot?.data?.attrs?.offset == undefined &&
    context.props.gutter == undefined
  )
    return {};
  return { 'padding-top': slot?.data?.attrs?.offset || context.props.gutter };
}

function getNegativeMargin(context) {
  if (context.props.gutter == undefined) return {};
  return { 'margin-top': `-${context.props.gutter}` };
}

export default {
  functional: true,
  props: {
    noPadding: Boolean
  },
  render(createElement, context) {
    const slots = context.slots().default;
    if (!slots?.length) return;

    return createElement(
      'div',
      {
        class: ['b-column', context.data.staticClass],
        style: {
          ...getNegativeMargin(context),
          ...context.data.staticStyle,
          ...context.data.style
        }
      },
      slots
        .filter(slot => slot.tag)
        .map(slot =>
          createElement(
            'div',
            {
              class: [
                'b-column__element',
                { 'b-column__element--noPadding': context.props.noPadding }
              ],
              style: getStyle(slot, context)
            },
            [slot]
          )
        )
    );
  }
};
</script>

<style lang="scss" scoped>
.b-column {
  display: flex;
  flex-direction: column;

  &__element {
    padding-top: 16px;

    &--noPadding {
      padding: 0;
    }
  }
}
</style>